import * as React from 'react';
import './DashboardContent.scss';
import SwitchToClientsAccount from '../SwitchToClientsAccount';
import ManagePowerUsers from '../ManagePowerUsers';
import ChangePassword from '../ChangePassword';
import ManageECheck from '../ManageECheck';
import ManageCredits from '../ManageCredits';
import EcheckPaymentModel from 'src/model/echeckPayment.model';
import CreditModel from 'src/model/credit.model';
import UnlockUser from '../UnlockUser';
import PartSmartLoginWindow from '../PartSmartLoginWindow';
import UserModel from 'src/model/user.model';

interface IDashboardContentProps {
  selected: 'switch' | 'info' | 'ship' | 'card' | 'statement' |  'credit' |   'password' | 'manage' | 'password' | 'e-check' | 'credits' | 'unlock' | 'partsmartlogin';
  selectedPayment: EcheckPaymentModel;
  selectedCredit: CreditModel;
  handlePaymentDetails: (payment: EcheckPaymentModel) => void;
  handleCreditDetails: (credit: CreditModel) => void;
  userData: UserModel;
}

export function DashboardContent(props: IDashboardContentProps) {
  const isSuperUserForPartSmart = props.userData?.permission.includes("SUPER_USER");
  const isPowerUserForPartSmart = props.userData?.permission.includes("POWER_USER");
  /* Set Superuser Id and email for Front partSmart Link */
    localStorage.setItem('gblSuperId', props.userData.specialUser);
    localStorage.setItem('gblSuperEmail', props.userData.specialUserEmail);
  if (isSuperUserForPartSmart || isPowerUserForPartSmart) {
    if(props.userData.partsmartUsername!=="" && props.userData.partsmartUsername !== null){
      localStorage.setItem('pUsr', props.userData.partsmartUsername);
    }
    if(props.userData.partsmartEmail!=="" && props.userData.partsmartEmail !== null){
      localStorage.setItem('pEmail', props.userData.partsmartEmail);
    }
  }
  function renderContent() {
    switch (props.selected) {
      case 'switch':
        return <SwitchToClientsAccount />;
      case 'info':
        return <SwitchToClientsAccount />;
      case 'ship':
        return <SwitchToClientsAccount />; 
      case 'card':
        return <SwitchToClientsAccount />; 
      case 'statement':
        return <SwitchToClientsAccount />;   
      case 'credit':
        return <SwitchToClientsAccount />;   
      case 'password':
        return <SwitchToClientsAccount />;                
      case 'manage':
        return <ManagePowerUsers />;
      case 'password':
        return <ChangePassword />;
      case 'e-check':
        return (
          <ManageECheck
            selectedPayment={props.selectedPayment}
            handlePaymentDetails={props.handlePaymentDetails}
          />
        );
      case 'credits':
        return (
          <ManageCredits
            selectedCredit={props.selectedCredit}
            handleCreditDetails={props.handleCreditDetails}
          />
        );
      case 'unlock':
        return <UnlockUser />;

      case 'partsmartlogin':
          return (
            <PartSmartLoginWindow
            superUserData={props.userData}
            />
          );  
      default:
        return null;
    }
  }

  return <div className="rp-dashboardcontent">{renderContent()}</div>;
}
